module.exports = __webpack_public_path__ + "static/media/postgre.ce7c58cc.svg";